import api from "@/services";

export default {
  methods: {
    async fetchData(endpoint) {
      try {
        const response = await api.get(endpoint);
        return response.data.data;
      } catch (error) {
        console.error(`Erro ao buscar dados de ${endpoint}:`, error);
        return [];
      }
    },
  },
};